import { push, replace } from 'connected-react-router'
import {resetDetailState} from "../Detail/actions";
import {resetQuestionsList} from "../Home/actions";
import {resetPostState} from "../Question/actions";

export const transitionToHome = () => {
    return (dispatch) => {
        dispatch(resetDetailState());
        dispatch(resetQuestionsList());
        dispatch(resetPostState());
        dispatch(push(`/`));
    }
};

export const transitionToDetail = (id) => {
    return (dispatch) => {
        dispatch(resetDetailState());
        dispatch(resetQuestionsList());
        dispatch(resetPostState());
        dispatch(push(`/detail/${id}`));
    }
};

export const transitionToPost = () => {
    return (dispatch) => {
        dispatch(resetDetailState());
        dispatch(resetPostState());
        dispatch(push('/post'));
    }
};

export const transitionToProfile = () => {
    return (dispatch) => {
        dispatch(resetDetailState());
        dispatch(resetQuestionsList());
        dispatch(resetPostState());
        dispatch(push(`/profile`));
    }
};


